angular.module('SpidApp')

.factory('SaleDbAdapter',
[        'Sale',
function (Sale) {
	var SaleDbAdapter = {
		fromModelToDb: function (sale) {
			if (!sale) {
				throw 'SaleDbAdapter::fromModelToDb() - Missing parameters'
			}

			return {
				  obj_id            : sale.obj_id
				, unit              : sale.quantity
				, weight            : sale.weight
				, price             : sale.price
				, label             : sale.label
				, local_price       : sale.localPrice
				, equinox           : sale.equinox
				, transaction_id    : sale.transactionId
				, obj_table_ref     : sale.type
			}
		},

		fromDbToModel: function (dbObject) {
			if (!dbObject) {
				throw 'SaleDbAdapter::fromDbToModel() - Missing parameters'
			}
			
			var sale = new Sale(dbObject.obj_table_ref, {
				  id                : dbObject.id
				, obj_id            : dbObject.obj_id
				, weight            : dbObject.weight
				, price             : dbObject.price
				, label             : dbObject.label
				, localPrice        : dbObject.local_price
				, equinox           : dbObject.equinox
				, quantity          : dbObject.unit
				, transactionId     : dbObject.transaction_id
			})
			
			return sale
		}
	}

	return SaleDbAdapter
}])

.factory('SaleService',
[        'Sale', 'SaleDbAdapter', 'Restangular',
function (Sale,   SaleDbAdapter,   Restangular) {
	var SaleService = {
		findByVacationId: function (agencyId, vacationId) {
			if ( agencyId === undefined || agencyId   === null ||
				vacationId === undefined || vacationId === null) {
				throw 'SaleService::findByVacationId() - Missing parameters'
			}

			return Restangular.one('agencies', agencyId).one('vacations', vacationId).all('sales').getList().then(function (salesData) {
				return _.map(salesData, function (saleData) {
					return SaleDbAdapter.fromDbToModel(saleData)
				})
			})
		},
        
        findByTransactionId: function(agencyId,transactionId){
            if ( agencyId === undefined || agencyId   === null ||
				transactionId === undefined || transactionId === null) {
				throw 'SaleService::findByTransactionId() - Missing parameters'
			}
            return Restangular.one('agencies', agencyId).one('transaction', transactionId).all('sales').getList().then(function (salesData) {
				return _.map(salesData, function (saleData) {
					return SaleDbAdapter.fromDbToModel(saleData)
				})
			})
        }
	}

	return SaleService
}])
